import { createBrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);
import { LandingPage } from '@/pages/landing/LandingPage';
import { ScanPage } from '@/pages/scan/ScanPage';
import { AuthCallbackPage } from '@/pages/auth-callback/AuthCallbackPage';
import { AuthGuestCallbackPage } from '@/pages/auth-guest-callback/AuthGuestCallbackPage';
import { LogoutPage } from '@/pages/logout/LogoutPage';
import { GuestEventPage } from '@/pages/guest-event/GuestEventPage';
import { GuestMyRequestsPage } from '@/pages/guest-my-requests/GuestMyRequestsPage';
import { DjDashboardPage } from '@/pages/dj-dashboard/DjDashboardPage';
import { DjEventsPage } from '@/pages/dj-events/DjEventsPage';
import { DjCreateEventPage } from '@/pages/dj-create-event/DjCreateEventPage';
import { DjEventDetailPage } from '@/pages/dj-event-detail/DjEventDetailPage';
import { DjSpotifyPage } from '@/pages/dj-spotify/DjSpotifyPage';
import { NotFoundPage } from '@/pages/not-found/NotFoundPage';
import { routePaths } from './routePaths';
import { ProtectedRoute } from './ProtectedRoute';
import { DjRoute } from './DjRoute';

export const router = sentryCreateBrowserRouter([
  // Public
  { path: routePaths.landing, element: <LandingPage /> },
  { path: routePaths.scan, element: <ScanPage /> },
  { path: routePaths.authCallback, element: <AuthCallbackPage /> },
  { path: routePaths.authGuestCallback, element: <AuthGuestCallbackPage /> },
  { path: routePaths.logout, element: <LogoutPage /> },
  { path: routePaths.eventPublic, element: <GuestEventPage /> },
  { path: routePaths.eventMyRequests, element: <GuestMyRequestsPage /> },

  // Authenticated
  {
    path: routePaths.djDashboard,
    element: <ProtectedRoute><DjRoute><DjDashboardPage /></DjRoute></ProtectedRoute>,
  },
  {
    path: routePaths.djEvents,
    element: <ProtectedRoute><DjRoute><DjEventsPage /></DjRoute></ProtectedRoute>,
  },
  {
    path: routePaths.djCreateEvent,
    element: <ProtectedRoute><DjRoute><DjCreateEventPage /></DjRoute></ProtectedRoute>,
  },
  {
    path: routePaths.djEventDetail,
    element: <ProtectedRoute><DjRoute><DjEventDetailPage /></DjRoute></ProtectedRoute>,
  },
  {
    path: routePaths.djEventRequests,
    element: <ProtectedRoute><DjRoute><DjEventDetailPage /></DjRoute></ProtectedRoute>,
  },
  {
    path: routePaths.djSpotify,
    element: <ProtectedRoute><DjRoute><DjSpotifyPage /></DjRoute></ProtectedRoute>,
  },

  // Catch-all
  { path: routePaths.notFound, element: <NotFoundPage /> },
]);
